import * as Yup from 'yup';
import { SUPPORT_DOCUMENT_TYPES } from '../utils/fileTypes';
import { URL_REG_EX } from '../utils/regex';

const FILE_SIZE = 50 * 1024;

export const fileDocumentInitialValues = (state) => {
  return {
    documentDescription:
      state.isUpdate && state.documentDescription
        ? state.documentDescription
        : '',
    documentTitle:
      state.isUpdate && state.documentTitle ? state.documentTitle : '',
    documentImageCredit:
      state.isUpdate && state.documentImageCredit
        ? state.documentImageCredit
        : '',
    documentFile: '',
  };
};

export const linkDocumentInitialValues = (state) => {
  return {
    documentDescription: state.documentDescription
      ? state.isUpdate && state.documentDescription
      : '',
    documentTitle:
      state.isUpdate && state.documentTitle ? state.documentTitle : '',
    documentUrlText:
      state.isUpdate && state.documentUrlText ? state.documentUrlText : '',
  };
};

export const fileDocumentValidationSchema = (state, t) => {
  return Yup.object().shape({
    documentTitle: Yup.string().required(
      t('formulary.validation.title_required')
    ),
    documentDescription: Yup.string().required(
      t('formulary.validation.description_required')
    ),
    documentImageCredit: Yup.string(),
    documentFile: Yup.mixed()

      .test('fileSize', t('formulary.validation.file_too_large'), (value) => {
        // if is it updating no need to trigger this validation
        if (state.isUpdate) return true;
        else if (!value) {
          return false;
        } else {
          const sizeComparison = Math.round(value.size / 1000) <= FILE_SIZE;
          return sizeComparison;
        }
      })
      .test(
        'fileFormat',
        t('formulary.validation.unsupported_file_format'),
        (value) => {
          // if is it updating no need to trigger this validation
          if (state.isUpdate) return true;
          else if (!value) {
            return false;
          } else return SUPPORT_DOCUMENT_TYPES.includes(value.type);
        }
      )
      .when([], () => {
        // if there is already uploaded file no need to trigger this validation
        if (!state.documentId || state.documentId === '')
          return Yup.string().required(
            t('formulary.validation.document_file_required')
          );
      }),
  });
};

export const linkDocumentValidationSchema = (t) =>
  Yup.object().shape({
    documentTitle: Yup.string().required(
      t('formulary.validation.title_required')
    ),
    documentDescription: Yup.string().required(
      t('formulary.validation.description_required')
    ),
    documentUrlText: Yup.string()
      .required(t('formulary.validation.link_required'))
      .matches(URL_REG_EX, t('formulary.validation.link_invalid')),
  });
